<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <b-card header="Forgot Your Password" header-tag="header" no-body>
            <b-card-body class="p-3">
              <h1 class="mx-auto d-block text-center mb-3">DigidoLMS</h1>
              <form @submit.prevent="reset">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text"><i class="icon-user"></i></div>
                  </div>
                  <input :class="{'form-control': true, 'is-invalid': errors.has('email')}"
                         v-validate="'required|email'"
                         data-vv-delay="500"
                         data-vv-as="Email"
                         data-vv-name="email"
                         type="text"
                         placeholder="Email"
                         name="email"
                         id="email"
                         autocomplete="email username"
                         v-model.trim="email"/>
                  <div class="invalid-tooltip d-block" v-if="errors.has('email')">{{ errors.first('email') }}</div>
                </div>
                <div class="input-group mb-3">
                  <loading-button variant="primary" block :loading="loading" @submit="reset">Reset Password</loading-button>
                </div>
              </form>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data () {
    return {
      loading: false,
      email: ''
    };
  },
  methods: {
    reset () {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true;
          this.axios.post('/auth/forgot', {email: this.email}).then(() => {
            this.$swal('Success', 'Please check your email.', 'success');
            this.loading = false;
            this.email = '';
            this.$validator.reset();
          }).catch(err => this.$errorOut(err));
        }
      });
    }
  },
  mounted () {
  },
  metaInfo: {
    title: 'Forgot Password'
  }
};
</script>

<style lang="scss">
  .page-forgotpassword {
    background: url("../../assets/img/login_bg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    color: black;
  }
</style>